export const eye_closed = () => (
  <path
    d="M1 12s4 8 11 8 11-8 11-8M2.697 14.611L1 16m20.302-1.389L23 16M5.521 17.528L4 20m14.482-2.467L20 20m-10.451-.337L9 22.5m5.451-2.836L15 22.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
